<template>
  <app-form-field :id="id" :title="title" :show-label="showLabel">
    <template #info>
      <slot name="info" />
    </template>
    <div class="euro-inp">
      <span class="euro-prefix"> € </span>
      <input
        :id="id"
        v-model="formattedValue"
        type="text"
        :name="name"
        :data-qa="id"
        maxlength="10"
        :tabindex="tabindex"
        :disabled="isReadOnly || null"
        @keydown.enter.prevent="tabOnEnter && nextField($event.target)"
        @change="updatePriceField"
      />
      <span v-if="$slots.default" class="extra">
        <slot />
      </span>
    </div>
  </app-form-field>
</template>

<script>
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import TabOnEnter from '@/mixins/tabOnEnter.js'

export default {
  components: {
    AppFormField,
  },
  mixins: [TabOnEnter],
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    fractionDigits: {
      type: Number,
      default: 2,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    truncate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue'],
  data() {
    return {
      formattedValue: '',
      numberValue: Number(0),
      currency: new Intl.NumberFormat('nl-NL', {
        style: 'decimal',
        minimumFractionDigits: this.fractionDigits,
        maximumFractionDigits: this.fractionDigits,
      }),
    }
  },
  watch: {
    modelValue() {
      this.formattedValue = this.currency.format(this.modelValue)
    },
  },
  mounted() {
    this.formattedValue = this.currency.format(this.modelValue)
  },
  methods: {
    updatePriceField() {
      this.numberValue = this.toNumber(this.formattedValue)
      this.formattedValue = this.currency.format(this.numberValue)
      this.$emit('update:modelValue', this.numberValue)
      this.$emit('change', this.numberValue)
    },
    toNumber(priceInput) {
      const matches = new RegExp(/\.\d{1,2}$/).test(priceInput)
      let number

      if (matches) {
        number = Number(priceInput)
      } else {
        number = Number(
          priceInput.replace(new RegExp(/\./, 'g'), '').replace(new RegExp(/\,/, 'g'), '.')
        )
      }

      if (Number.isNaN(number)) return 0

      return this.truncate ? Math.trunc(number) : number
    },
  },
}
</script>

<style lang="scss" scoped>
.euro-inp {
  display: flex;
  align-items: center;
}

.euro-prefix {
  font-size: 1rem;
  background: #dae2e5;
  padding: 0.41667rem 0.3rem;
}

.extra {
  margin-left: 1rem;
}
</style>
